// app.routing.js

//"use strict";

import { appDesktop } from "./app.states";
import { 
  desktopIndex,
  servicePriceIndex,
  servicePaymentIndex,
  personalApplicationsIndex,
  personalApplicationsPagedIndex,
  personalAppealsIndex,
  sendAppealsIndex,
  myApplicantsIndex,
  bidViewIndex,
  bidAnnulndex,
  bidAddFilesIndex,
  bidClaimTuIndex,
  bidProjectDocsIndex,
  bidIncomingDocsIndex,
  bidCloneService,


} from "./components/desktop/desktop.module.states";

import {
  bidEditIndex,
  bidStep1Index,
  bidStep2Index,
  bidStep3Index
} from "./components/desktop/bid/bid.module.states"

import {
  servicePaymentBill,
  servicePaymentInvoice,
  servicePaymentDocs,
  servicePaymentOnline,
  servicePaymentReceipt,
  servicePaymentReceiptIndex
} from "./components/desktop/services-payment/service-payment.module.states"

import {
  applicantEditIndex,
  applicantEditIndividual,
  applicantEditSelfEmployed,
  applicantEditOrganization
} from "./components/desktop/my-applicants/applicant.module.states"


//import MOETP_APP from "./app";

appRouting.$inject = [ "$stateProvider", "$locationProvider", "$logProvider", "bxMenuProvider"];

function appRouting($stateProvider, $locationProvider, $logProvider, bxMenuProvider) {
  $logProvider.debugEnabled(false);
  $locationProvider.html5Mode(true);

  

  $stateProvider.state(appDesktop);
  $stateProvider.state(desktopIndex);
  $stateProvider.state(servicePriceIndex);
  $stateProvider.state(servicePaymentIndex);
  $stateProvider.state(personalApplicationsIndex);
  $stateProvider.state(personalApplicationsPagedIndex);
  
  $stateProvider.state(personalAppealsIndex);
  $stateProvider.state(sendAppealsIndex)
  $stateProvider.state(myApplicantsIndex)


  $stateProvider.state(bidEditIndex)
  $stateProvider.state(bidStep1Index)
  $stateProvider.state(bidStep2Index)
  $stateProvider.state(bidStep3Index)
  

  $stateProvider.state(bidViewIndex)
  $stateProvider.state(bidAnnulndex)
  $stateProvider.state(bidAddFilesIndex)
  $stateProvider.state(bidCloneService)

  $stateProvider.state(bidClaimTuIndex)
  $stateProvider.state(bidProjectDocsIndex)
  $stateProvider.state(bidIncomingDocsIndex)

  $stateProvider.state(servicePaymentBill)
  $stateProvider.state(servicePaymentInvoice)
  $stateProvider.state(servicePaymentDocs)
  $stateProvider.state(servicePaymentOnline)
  $stateProvider.state(servicePaymentReceipt)
  $stateProvider.state(servicePaymentReceiptIndex)

  $stateProvider.state(applicantEditIndex)
  $stateProvider.state(applicantEditIndividual)
  $stateProvider.state(applicantEditSelfEmployed)
  $stateProvider.state(applicantEditOrganization)

  bxMenuProvider
  .loadMenu()
  .then(function (menu) {
   // MOETP_APP.constant('desktopMenu', menu);


    let bx = window.BX;
    bx.onCustomEvent('onDesktopMenuLoaded', [menu]);

  });



}


export { appRouting };



// WEBPACK FOOTER //
// ./src/app.routing.js